<template>
  <div id="app">
    <el-container>
      <el-header>
        <div @click="goIndex" class="logo" style="width: 150px;margin-left: 150px;margin-right: 100px;display:flex;align-items: center">
          <img style="width: 50px;" mode="aspectFit" src="./assets/img/toplogo.png" alt />
          <div style="font-size:25px;margin-left: 5px">PlantPP</div>
        </div>
        <el-menu
            @select="handleSelect"
            mode="horizontal"
            text-color="#000000"
            style="font-weight: bold;"
            :default-active="activeIndex"
        >
          <el-menu-item index="/">Home</el-menu-item>
          <el-menu-item index="/help">Help</el-menu-item>
          <el-menu-item index="/analyze">Analyze</el-menu-item>
          <el-menu-item index="/about">About</el-menu-item>
        </el-menu>
        <div style="flex-grow: 1"></div>
        <el-menu
            mode="horizontal"
            @select="handleSelect"
            text-color="#000000"
            style="font-weight: bold;"
            :router="router"
            :default-active="activeIndex"
        >
          <el-submenu index="/register">
            <template slot="title">Account</template>
            <el-menu-item v-if="!login" index="/login">Login</el-menu-item>
            <el-menu-item v-if="!login" index="/register">Register</el-menu-item>
            <el-menu-item v-if="login" index="/account">Account</el-menu-item>
            <el-menu-item v-if="login" index="/logout">Logout</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      login:false,
      activeIndex: "/",
    };
  },
  created() {
    this.activeIndex = this.$route.path;
  },
  watch: {
    $route(to) {
      this.activeIndex = to.path;
    }
  },
  mounted() {
    this.login = localStorage.getItem("login");
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    handleStorageChange(event) {
      if (event.key === 'login') {
        this.login = event.newValue
        console.log('login 键发生了变化', this.login)
      }
    },
    handleSelect(key, keyPath) {
      if (key === '/logout') {
        localStorage.removeItem("userId")
        localStorage.removeItem("login")
        location.reload()
        this.$router.push({
          path: `/`,
        })
      }else {
        this.$router.push({
          path: key,
        })
      }
    },
    goIndex(){
      this.$router.push({
        path: `/`,
      })
    },
  }
};
</script>

<style >
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
  background-color: #ffffff;
}
.el-main {
  padding: 0px !important;
  padding-top: 10px;
}

.el-header {
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 150px;
  background-color: white;
  border-bottom: 1px solid #e6e6e6;
}
.el-menu-item:hover{
  background-color: #fb9348 !important;
  color: white !important;
}
.el-submenu__title:focus, .el-submenu__title:hover{
  background-color: #fb9348 !important;
  color: white !important;
}

</style>
